export default __webpack_public_path__ + "static/media/889.183fcfd9.png";